import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccordionItemLink, Category } from '../../shared/components/accordion/accordion-item.model';

@Injectable({
  providedIn: 'root'
})
export class LinkUtilService {
  private apiUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getAccordionItems(page = 1, size = 100): Observable<AccordionItemLink[]> {
    const url = `${this.apiUrl}/cms/link-categories`;
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('inactive', 'false')
      .set('sortField', 'order')
      .set('sortOrder', 'asc');

    return this.http.get<{ data: Category[] }>(url, { params }).pipe(
      map(response =>
        response.data.map(category => ({
          name: category.name,
          links: category.links
        }))
      )
    );
  }
}